// Dashboard.jsx - Fixed version
import {
  ChartColumnStacked,
  ChevronDown,
  Map,
  Video
} from "lucide-react";
import {
  useCallback,
  useEffect,
  useMemo,
  useState
} from "react";
import { useNavigate } from "react-router-dom";
import "../App.css";
import ViolationList from "../components/dashboard/ViolationList";
import Navbar from "../components/navigation/Navbar";
import { AlarmsPanel } from "../components/ui/Alarms";
import { AlertsPanel } from "../components/ui/Alerts";
import { useAuth } from "../context/AuthContext";
import * as allauth from "../library/allauth";
import { Client, getSessionToken, settings } from "../library/allauth";
import { getCSRFToken } from "../library/django";
import { useRegions } from "../context/RegionsContext";
import React from "react";
import MapComponent from "../components/map/mapComponent";

export default function Dashboard() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const { getSystemsByRegion, isLoading, regions } = useRegions();
  const [userGroups, setUserGroups] = useState([]);
  const [alertsExpanded, setAlertsExpanded] = useState(true);
  const [alarmsExpanded, setAlarmsExpanded] = useState(false);
  const [trafficExpanded, setTrafficExpanded] = useState(true);
  const { FirstName } = useAuth() || {} ;
  const [filter] = useState({
    systemId: "1",
    interval: "60",
    startDate: "2025-08-25",
    startTime: "19:39:39",
  });
  const [loading, setLoading] = useState(false);
  const [dummyResponse, setDummyResponse] = useState({ status: "", data: "" });

  const alerts = useMemo(
    () => [
      // {
      //   id: 1,
      //   message: "CCTV feed offline — Intersection 12",
      //   severity: "high",
      //   time: "2 min ago",
      // },
      // {
      //   id: 2,
      //   message: "LiDAR error alert — Cambridge Route 1",
      //   severity: "medium",
      //   time: "15 min ago",
      // },
      // {
      //   id: 3,
      //   message: "Network latency detected — Boston Hub",
      //   severity: "low",
      //   time: "1 hour ago",
      // },
    ],
    []
  );

  const alarms = useMemo(
    () => [
      // {
      //   id: 1,
      //   message: "Scheduled maintenance — Oct 14, 9:00 AM",
      //   type: "maintenance",
      //   time: "Tomorrow",
      // },
      // {
      //   id: 2,
      //   message: "Emergency alert — Boston intersection 6",
      //   type: "emergency",
      //   time: "Now",
      // },
    ],
    []
  );

  // Stable function reference using useCallback
  const handleViewDetails = useCallback(() => {
    sessionStorage.setItem(
      "kpiFilter",
      JSON.stringify({
        ...filter,
        chartType: "stacked",
        source: "dashboard",
      })
    );
    navigate("/dashboard");
  }, [filter, navigate]);

  // Stable function for formatting date
  const formatDateForBackend = useCallback((dateString, timeString) => {
    if (!dateString) return "";
    const date = new Date(dateString + "T" + timeString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }, []);


  // Stable function for fetching user groups
  const fetchUserGroups = useCallback(async () => {
    try {
      const response = await allauth.getUserGroups();
      if (response.status === 200) {
        setUserGroups(response.data.groups || []);
      }
    } catch (error) {
      console.error("Error fetching user groups:", error);
    }
  }, []);

  // Initial data fetch
  useEffect(() => {
    fetchUserGroups();
  }, [fetchUserGroups]);



  // Memoize getQuickAccessItems
  const getQuickAccessItems = useMemo(
    () => [
      {
        label: "Dashboard",
        href: "/dashboard",
        icon: ChartColumnStacked,
      },
      { label: "Footage", href: "/videos", icon: Video },
      { label: "Map", href: "/map", icon: Map },
    ],
    []
  );

  // Create stable handler for expand button
  const handleExpandClick = useCallback(
    (e) => {
      e.stopPropagation();
      handleViewDetails();
    },
    [handleViewDetails]
  );

  const get_total_systems = (region_id) => {
    return getSystemsByRegion(region_id).length
  }

  return (
    <>
      <Navbar />
      <section className="pt-14">
        <div className="grid gap-6 p-6 grid-cols-1">
          <div className="space-y-6">
            <div className="bg-white rounded-lg p-5 shadow-sm border border-gray-200">
              <div className="flex items-center justify-between">
                <div>
                  <div className="flex items-center gap-3 mb-1">
                    <h1 className="text-xl font-semibold text-gray-800">
                      Welcome {user?.first_name || user?.username || "User"}
                    </h1>
                    <span className="px-3 py-1 bg-purple-100 text-purple-700 text-xs rounded font-medium">
                      {regions.length - 1} Regions
                    </span>
                  </div>
                  <p className="text-sm text-gray-500">
                  </p>
                </div>

                {/* Message and Help Buttons */}
                {/* <div className="flex items-center gap-3">
                  <button disabled className="flex items-center gap-2 px-5 py-2.5 bg-white border-2 border-gray-300 rounded-lg hover:bg-gray-50 transition-colors opacity-50 cursor-not-allowed">
                    <MessageSquare size={20} className="text-gray-700" />
                    <span className="text-sm font-medium text-gray-700">
                      Message
                    </span>
                  </button>
                  <button disabled className="flex items-center gap-2 px-5 py-2.5 bg-emerald-600 text-white rounded-lg hover:bg-emerald-700 transition-colors opacity-50 cursor-not-allowed">
                    <HelpCircle size={20} />
                    <span className="text-sm font-medium">Help</span>
                  </button>
                </div> */}
              </div>
            </div>

            <div className="grid md:grid-cols-12 gap-4 grid-cols-1">
              <div className="col-span-6 space-y-4 ">
                <div className="bg-white rounded-lg p-4 shadow-sm border border-gray-200">
                  <h3 className="text-sm font-semibold text-gray-800 mb-4">
                    Quick Access
                  </h3>
                  <div className="grid grid-cols-3 gap-3">
                    {getQuickAccessItems.map((item, index) => {
                      const IconComponent = item.icon;

                      return (
                        <a
                          key={index}
                          href={item.href}
                          className={
                            "flex flex-col items-center p-5 bg-white border-2 border-gray-200 rounded-lg hover:border-gray-300 hover:shadow-sm transition-all"
                          }
                        >
                          {IconComponent && (
                            <IconComponent
                              size={32}
                              className="text-[#667085] mb-3"
                            />
                          )}
                          <span className="text-xs text-gray-700 font-medium">
                            {item.label}
                          </span>
                        </a>
                      );
                    })}
                  </div>
                </div>

                <AlertsPanel
                  alerts={alerts}
                  isExpanded={alertsExpanded}
                  onToggle={() => setAlertsExpanded(!alertsExpanded)}
                />

                <AlarmsPanel
                  alarms={alarms}
                  isExpanded={alarmsExpanded}
                  onToggle={() => setAlarmsExpanded(!alarmsExpanded)}
                />

                
              </div>

              {/* MIDDLE COLUMN */}
              <div className="col-span-6 space-y-6 ">
                <ViolationList className="bg-white rounded-lg border border-gray-200" />
                <div className="bg-white rounded-lg p-4 shadow-sm border border-gray-200">
                  <h3 className="text-sm font-semibold text-gray-800 mb-4">
                    Systems Details
                  </h3>
                  <div className="overflow-x-auto">
                    <table className="w-full text-xs">
                      <thead>
                        <tr className="text-gray-500 border-b border-gray-200">
                          <th className="text-left py-2 font-medium">Region</th>
                          <th className="text-right py-2 font-medium">
                            <div className="flex items-center justify-end gap-1">
                              System
                            </div>
                          </th>

                        </tr>
                      </thead>
                      <tbody>
                        {regions.map((region) => (
                          <tr className="border-b border-gray-100">
                            <td className="py-3 text-gray-700">{region.region_name}</td>
                            <td className="py-3 text-right text-gray-700">{get_total_systems(region.region_id)}</td>
                          </tr>
                        ))}

                      </tbody>
                    </table>
                  </div>
                </div>
                
              </div>

              <div className="col-span-12 space-y-6 min-h-[400px]">
                <MapComponent useGlobalRegion={true} />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
